import React, { useState } from "react";
import ImageKit from "imagekit-javascript";
import { Spinner } from "react-bootstrap";
import upload from "../../../images/upload-2-line.svg";

const Upload = ({
  data,
  CouncilProfile,
  refetch,
  type,
  setImageUrl,
  ImageType,
  iconVisible,
}) => {
  const [imageUploading, setImageUploading] = useState(false);
  const imageKit = new ImageKit({
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });
  return (
    <div className=" loading">
      <div className="loading-cover">
        {imageUploading ? (
          <Spinner className="spinner" animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        ) : (
          <>
            <div className="council-banner-edit">
              <label className="form-group">
                <input
                  type="file"
                  id="file1"
                  style={{ display: "none" }}
                  onChange={async (event) => {
                    if (event.target.files[0].type.includes("image")) {
                      event.persist();
                      setImageUploading(true);
                      await imageKit.upload(
                        {
                          file: event.target.files[0],
                          fileName: event.target.files[0].name,
                          tags: ["tag1"],
                          folder: `/dev/council_profile/${localStorage.getItem(
                            "profile_id"
                          )}`,
                        },
                        (err, result) => {
                          if (result) {
                            if (type === "change") {
                              setImageUrl(
                                imageKit.url({
                                  src: result.url,
                                })
                              );
                              setImageUploading(false);
                            } else {
                              if (ImageType === "header") {
                                CouncilProfile({
                                  variables: {
                                    data: {
                                      council_profile_photo: imageKit.url({
                                        src: result.url,
                                      }),
                                      council_profile_path: `/dev/council_profile/${localStorage.getItem(
                                        "profile_id"
                                      )}`,
                                    },
                                    user_id: `${
                                      data && data.users[0] && data.users[0].id
                                        ? data.users[0].id
                                        : ""
                                    }`,
                                  },
                                })
                                  .then(() => {
                                    refetch();
                                  })
                                  .catch(() => {});
                              } else {
                                CouncilProfile({
                                  variables: {
                                    data: {
                                      council_cover_photo: imageKit.url({
                                        src: result.url,
                                      }),
                                      council_cover_path: `/dev/council_profile/${localStorage.getItem(
                                        "profile_id"
                                      )}`,
                                    },
                                    user_id: `${
                                      data && data.users[0] && data.users[0].id
                                        ? data.users[0].id
                                        : ""
                                    }`,
                                  },
                                })
                                  .then(() => {
                                    refetch();
                                  })
                                  .catch(() => {});
                              }

                              setImageUploading(false);
                            }
                          }
                        }
                      );
                    }
                  }}
                />
                {type === "change" ? (
                  <div className="cancel-btn">Change Photo</div>
                ) : (
                  <div className="cancel-btn upload-btn">
                    {iconVisible ? (
                      <img src={upload} alt="upload" />
                    ) : (
                      <p>upload</p>
                    )}
                  </div>
                )}
              </label>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Upload;
